module.exports = __webpack_public_path__ + "static/media/dish.fbca1a1f.svg";